import { createSlice, current } from '@reduxjs/toolkit';

const initialState = {
  currentAlert: null,
  alerts: []
}

const globalAlertsSlice = createSlice({
  name: 'globalAlerts',
  initialState,
  reducers: {
    addAlert(state, action) {
      const { message, severity } = action.payload
      const currentAlert = current(state).currentAlert
      if (currentAlert) {
        state.alerts.push({ id: Date.now(), message, severity, visible: true })
      } else {
        state.currentAlert = ({ id: Date.now(), message, severity, visible: true })
      }
    },
    hideAlertBeforeClose(state, action) {
      state.currentAlert.visible = false
    },
    closeAlert(state, action) {
      const nextAlert = current(state)?.alerts[0]
      if (nextAlert) {
        state.currentAlert = nextAlert
        state.alerts.shift()
      } else {
        state.currentAlert = null
      }
    },
  },
});

export const { addAlert, hideAlertBeforeClose, closeAlert } = globalAlertsSlice.actions;
export const selectAlertState = (state) => state.globalAlertsSlice
export const selectAlerts = (state) => state.globalAlertsSlice.alerts

export default globalAlertsSlice.reducer;